var _line, _line2, _line3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 748,
    height: 566,
    viewBox: "0 0 748 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 251.419,
    y1: 307.728,
    x2: 373.419,
    y2: 495.728,
    stroke: "#D9D9D9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 373.393,
    y1: 82.6908,
    x2: 698.393,
    y2: 495.691,
    stroke: "#D9D9D9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 71.6039,
    y1: 465.695,
    x2: 366.604,
    y2: 82.6949,
    stroke: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.409,
    cy: 274.396,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.409,
    cy: 57.3958,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.233,
    cy: 274.577,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.4092,
    cy: 508.396,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#0291D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.758,
    cy: 507.604,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#0291D9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 698.409,
    cy: 508.396,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.409,
    cy: 274.396,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.409,
    cy: 57.3958,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.233,
    cy: 274.577,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.4092,
    cy: 508.396,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#0291D9"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.758,
    cy: 507.604,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#0291D9"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 698.409,
    cy: 508.396,
    rx: 49.4092,
    ry: 57.3958,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDom1);
export default __webpack_public_path__ + "static/media/dom-1.cef9ccbd409a1db3f03a49fc2dd42545.svg";
export { ForwardRef as ReactComponent };